import { AUTH_API, handleApiError } from '../../utils/axios';

export const getMe = async () => {
  try {
    const response = await AUTH_API.get('/api/v1/me');
    return { error: null, data: response.data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const changePassword = async (passwordRequest) => {
  try {
    const response = await AUTH_API.post('/api/v1/me/change-password', passwordRequest);
    return { error: null, data: response.data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const updateMe = async (meRequest) => {
  try {
    const response = await AUTH_API.put('/api/v1/me', meRequest);
    return { error: null, data: response.data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const getMyVehicles = async (search) => {
  try {
    const { data } = await AUTH_API.get(
      `/api/v1/me/vehicles?page=${search.page}&size=${search.size}&search=${search.search}`,
    );
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const getMyVisits = async (search) => {
  try {
    const { data } = await AUTH_API.get(
      `/api/v1/me/visits?page=${search.page}&size=${search.size}&search=${search.search}&status=${search.status}`,
    );
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const getMyAnalytics = async () => {
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const { data } = await AUTH_API.get(`/api/v1/me/analytics`, {
      headers: {
        ...AUTH_API.defaults.headers,
        'X-Timezone': timezone,
      },
    });
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};
